export default __webpack_public_path__ + "static/pattern_01-01cb9b8e9b6d8f7d730d8f6e1c081bce.png";